<template>
  <div class="page" id="page-aboutus">

    <div class="section-header">
      <div class="container">
        <h1>주요 연혁</h1>
      </div>
    </div>

    <div class="section-body" id="history">
      <div class="container">

        <div class="subsection-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '현재~2011'" :on="introductionTab == '현재~2011'">현재 ~ 2011</element-tab-item>
              <element-tab-item @click="introductionTab = '2010~2001'" :on="introductionTab == '2010~2001'">2010 ~ 2001</element-tab-item>
              <element-tab-item @click="introductionTab = '2000~1985'" :on="introductionTab == '2000~1985'">2000 ~ 1985</element-tab-item>
            </element-tab>
          </div>
        </div>

        <div class="subsection-body">
          <div class="container">


            <div class="subsection" v-if="introductionTab == '현재~2011'">
              <div class="subsection-title">
                현재 ~ 2011
              </div>
              <div class="subsection-list">
                <ul>
                  <li class="year" v-for="years in histories_by_now" id="history-years">
                    <ul>
                      <li v-for="(items, index) in years.data">
                        <div class="item-year">
                          {{ index == 0 ? years.year : " " }}
                        </div>
                        <div class="item-month">
                          {{ items.month }}
                        </div>
                        <div class="item-description">
                          {{ items.description }}
                        </div>
                        <template v-if="items.link">
                          <a class="sns-item" :href="items.link" target="_blank">
                            <img :src="'../static/' + items.icon">
                          </a>
                        </template>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            <div class="subsection" v-if="introductionTab == '2010~2001'">
              <div class="subsection-title">
                2010 ~ 2001
              </div>

              <div class="subsection-list">
                <ul>
                  <li class="year" v-for="years in histories_by_2011" id="history-years">
                    <ul>
                      <li v-for="(items, index) in years.data">
                        <div class="item-year">
                          {{ index == 0 ? years.year : " " }}
                        </div>
                        <div class="item-month">
                          {{ items.month }}
                        </div>
                        <div class="item-description">
                          {{ items.description }}
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            <div class="subsection" v-if="introductionTab == '2000~1985'">
              <div class="subsection-title">
                2000 ~ 1985
              </div>

              <div class="subsection-list">
                <ul>
                  <li class="year" v-for="years in histories_by_2000" id="history-years">
                    <ul>
                      <li v-for="(items, index) in years.data">
                        <div class="item-year">
                          {{ index == 0 ? years.year : " " }}
                        </div>
                        <div class="item-month">
                          {{ items.month }}
                        </div>
                        <div class="item-description">
                          {{ items.description }}
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  data(){
    return {
      introductionTab: "현재~2011",
      histories_by_now: [
        { 'year': '2020년', 'data': [
            { 'month': '05월', 'description': '주-플라카(차집사 앱) 빅데이터 마이닝 제휴' },
            { 'month': '04월', 'description': '인스타그램 개설', 'link': 'https://www.instagram.com/insunetfc/?hl=ko', 'icon': 'icon_sns_instagram3.png'},
            { 'month': '', 'description': '유튜브 개설', 'link': 'https://www.youtube.com/channel/UCJFA_J1DCE7htDBmm9WvPqA', 'icon': 'icon_sns_youtube.png'},
            { 'month': '', 'description': '페이스북 개설', 'link': 'https://www.facebook.com/%EC%9D%B8%EC%8A%88%EB%84%B7FC-132253598456903/?modal=admin_todo_tour', 'icon': 'icon_sns_facebook.png'},
            { 'month': '', 'description': '트위터 개설', 'link': 'https://twitter.com/insunetfc', 'icon': 'icon_sns_twitter.png'},
            { 'month': '', 'description': '네이버 블로그 개설', 'link': 'https://blog.naver.com/insunetfc', 'icon': 'naver_blog.png'},
            { 'month': '', 'description': '다음 블로그 개설', 'link': 'http://blog.daum.net/insunetfc', 'icon': 'daum.png'},
            { 'month': '', 'description': '네이버 카페 개설', 'link': 'https://cafe.naver.com/insunetfc', 'icon': 'naver_cafe.png'},
            { 'month': '', 'description': '다음 카페 개설', 'link': 'http://cafe.daum.net/insunetfc', 'icon': 'daum.png'},
            { 'month': '03월', 'description': "웹사이트 신규 오픈(www.insunetfc.com) " },
            { 'month': '', 'description': "상명대학교 핀테크인텔리전스 전공 공동운영 협약" }
          ]
        },
        { 'year': '2019년', 'data': [
          { 'month': '11월', 'description': "보험포털 ERP 웹 버전 신규 개발" }
        ]},
        { 'year': '2018년', 'data': [
          { 'month': '03월', 'description': "대학교재 '전략경영과 경쟁우위' 성공사례 부문 소개" },
          { 'month': '04월', 'description': '인슈넷에서 인슈넷에프씨 독립회사로 분리' },
          { 'month': '12월', 'description': '보험영업 인공지능 챗봇 개발' },
        ]},
        { 'year': '2016년', 'data': [
          { 'month': '04월', 'description': "4차산업 혁명 동반성장 학술대회 practice 부분 참여" }
        ]},
        { 'year': '2015년', 'data': [
          { 'month': '11월', 'description': "인슈넷으로부터 보험영업권 양도" },
          { 'month': '10월', 'description': "인슈넷 자회사로 편입" }
        ]},

        { 'year': '2011년', 'data': [
          { 'month': '06월', 'description': '손해보험협회 우수인증대리점 수상' },
          { 'month': '04월', 'description': '롯데손해 CY2011 1/4분기 자동차보험 부문 공로패 수상' },
        ]}
      ],

      histories_by_2011: [
        { 'year': '2010년', 'data': [
          { 'month': '06월', 'description': '현대해상 FY2009 CS 우수 법인 선정 및 고객만족경영 부문 \'대상\' 수상' },
          { 'month': '', 'description': '손해보험협회 손해보험 우수인증대리점 선정' },
        ]},
        { 'year': '2009년', 'data': [
          { 'month': '07월', 'description': '' },
          { 'month': '', 'description': '메리츠화재 FY2008 연도대상 Agency 부문 \'은상\' 수상' },
          { 'month': '', 'description': '동부화재 2008 DHC(Dongbu Honors Club) \'Gold\' 수상' },
          { 'month': '04월', 'description': '삼성화재 \'2008 Honor\'s ART Diamond\' 수상' }
        ]},
        { 'year': '2008년', 'data': [
          { 'month': '11월', 'description': '동부화재 FY2008 상반기 DHC(Dongbu Honors Club) \'PLATINUM\' 수상' },
          { 'month': '05월', 'description': '동부화재 2008 DHC(Dongbu Honors Club) \'동상\' 수상' },
          { 'month': '04월', 'description': '삼성화재 2007 GRAND SLAM \'Gold\' 수상' }
        ]},
        { 'year': '2007년', 'data': [
          { 'month': '11월', 'description': '메트라이프생명 보험사와 보험 대리점 계약' },
          { 'month': '07월', 'description': '메리츠화재 \'장기 전문 Agency상\' 수상' },
          { 'month': '05월', 'description': '메리츠화재 FY2006 연도대상 \'Agency 부문\' 수상' },
          { 'month': '', 'description': '제일화재 연도대상 \'법인대리점상\' 수상' },
          { 'month': '03월', 'description': '동부생명 보험사와 보험 대리점 계약' },
        ]},
        { 'year': '2006년', 'data': [
          { 'month': '11월', 'description': '한국신용평가정보(KIS)에서 종합신용등급 AA+(매우 우량) 획득' },
          { 'month': '03월', 'description': '지식 마케팅 연구소 개설' },
        ]},
        { 'year': '2005년', 'data': [
          { 'month': '12월', 'description': '럭키(現 우리아비바), 교보, 알리안츠 등 3개 생명 보험사와 보험 대리점 계약' },
        ]},
        { 'year': '2004년', 'data': [
          { 'month': '12월', 'description': '금호, PCA 등 2개 생명 보험사와 보험 대리점 계약' },
          { 'month': '05월', 'description': '제일화재 FY2003 연도대상 \'우수업적공로상\' 수상' },
        ]},
        { 'year': '2003년', 'data': [
          { 'month': '12월', 'description': '동양, 리아나, AIG, 삼성, 대한 등 5개 생명 보험사와 보험 대리점 계약' },
          { 'month': '', 'description': 'MBC 114 등 12개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '08월', 'description': '\'i Weekly\' 표지' },
          { 'month': '06월', 'description': '쌍용화재 FY2002 연도대상 \'특별상\' 수상' },
          { 'month': '', 'description': '제일화재 FY2002 연도대상 \'특별상\' 수상' },
          { 'month': '05월', 'description': '대한화재(現 롯데손해) FY2002 연도대상 \'특별공로상\' 수상' },
        ]},
        { 'year': '2002년', 'data': [
          { 'month': '12월', 'description': '한국신용평가정보(KIS)에서 종합신용등급 A-(우량) 획득' },
          { 'month': '', 'description': '국민일보, 인터파크 등 50개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '05월', 'description': '쌍용화재(現 흥국화재) FY2001 연도대상 \'특별상\' 수상' },
          { 'month': '03월', 'description': '쌍용화재(現 흥국화재) \'공로상\' 수상' },
        ]},
        { 'year': '2001년', 'data': [
          { 'month': '12월', 'description': '(주)인슈넷으로 상호 변경' },
          { 'month': '', 'description': '현대캐피탈, 제일은행 등 55개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '06월', 'description': '동양화재(現 메리츠화재) \'다이아몬드 회원\' 선정' },
          { 'month': '05월', 'description': '안심메일 발송 시작' },
          { 'month': '', 'description': '여의도동 44-25번지에 사옥을 구입하여 회사 이전' },
          { 'month': '04월', 'description': '삼성화재 제 7회 연도대상 \'특별상\', \'특별공로상\' 수상' },
        ]},
      ],

      histories_by_2000: [
        { 'year': '2000년', 'data': [
          { 'month': '12월', 'description': '네띠앙, 드림위즈 등 87개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '10월', 'description': '금융감독위원회 법인 등록(00335711)' },
          { 'month': '04월', 'description': '현대해상 \'VIP CLUB 회원\' 선정' },
        ]},
        { 'year': '1999년', 'data': [
          { 'month': '12월', 'description': '야후!코리아, 다음커뮤니케이션즈 등 33개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '11월', 'description': '보험 업계 최초로 벤처 기업 등록' }
        ]},
        { 'year': '1998년', 'data': [
          { 'month': '12월', 'description': '골드뱅크, 엠파스 등 14개 업체와 보험 정보 제공 계약 체결' },
          { 'month': '05월', 'description': '인터넷 보험료 비교 견적 서비스 제공' }
        ]},
        { 'year': '1997년', 'data': [
          { 'month': '12월', 'description': '기프트서울, 평화피닉스와 보험업무 제휴 계약 체결' },
          { 'month': '07월', 'description': '한겨레신문과 보험업무 제휴 계약 체결' },
          { 'month': '05월', 'description': '보험 업계 최초의 독립 대리점 탄생' },
          { 'month': '', 'description': '11개 전체 손해 보험사와 보험 대리점 계약 완료' },
          { 'month': '02월', 'description': 'LG화재(現 LIG손해) 자동차보험 부문 \'매출상\' 수상' },
        ]},
        { 'year': '1994년', 'data': [
          { 'month': '06월', 'description': '(주)한맥인스코로 법인 전환' },
          { 'month': '03월', 'description': '하이텔, 나우누리, 천리안에 보험 정보 제공 계약' },
        ]},
        { 'year': '1992년', 'data': [
          { 'month': '01월', 'description': '안국화재(現 삼성화재) 창립 40주년 \'공로상\' 수상' },
        ]},
        { 'year': '1985년', 'data': [
          { 'month': '08월', 'description': '한백대리점 최초 설립' },
        ]},
      ],
    }
  }
}
</script>
